
import {Component, Prop} from 'vue-property-decorator'
import {Base} from '~/core/Base'
import BaseInput from '~/core/BaseInput'

@Component
export default class ButtonLight extends Base {
  @Prop(String) readonly icon!: string
  @Prop(String) readonly buttonText!: string
  @Prop(Boolean) readonly fullWidth!: boolean
  @Prop(Boolean) readonly iconOnly!: boolean
  @Prop(Boolean) readonly disabled!: boolean
  @Prop({type: Boolean, default: false}) readonly isOutlined?: boolean
  @Prop({type: Boolean, default: false}) readonly isBGPrimary?: boolean
  @Prop({type: String, default: 'submit'}) readonly type!: string
  @Prop(String) readonly to!: string
}
